import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MatDialogRef } from "@angular/material/dialog";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MasterService } from "src/app/services/master.service";
import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";
import { LoginService } from "src/app/services/login.service";

@Component({
  selector: "app-modal",
  templateUrl: "./tenement-modal.html",
  styleUrls: ["./tenement-modal.scss"],
})
export class TenementModalComponent implements OnInit {
  key: number;
  base64File: string;
  public uploadedDocument: string;
  public uploadedDocumentTimestamp: Date;
  public isFileUploaded: boolean = false;
  form: FormGroup = new FormGroup({});
  selectedFile: File;
  corrigendumName: string = "";
  isLoading = false;
  CorrigendumResponseModel: CorrigendumUploadModel;
  corrigendumFileNameSelect: string;
  pageMode: string;
  corrigendumBase64: string;
  isOtpVerify: boolean = false;
  pageHead: string = "Login";
  maskMobileNumber: string;
  maskMobileNumberForFirstAppli: string;
  maskMobileNumberForSecondAppli: string;
  luser: TenementExchangeOtpModel = new TenementExchangeOtpModel();
  @Input() toApplicantData: any;
  @Input() fromApplicantData: any;
  @Input() exchangeType: any;

  isSubmitDisabled: boolean = false;
  isResendOtpButtonVisible: boolean = false;
  resendOtpIn: any = null;
  timerOn = true;

  FileNameList: any[] = [
    { name: "Corrigendum", value: "Corrigendum" },
    {
      name: "Caste Validity Verification",
      value: "Caste Validity Verification",
    },
    {
      name: "Important Announcement",
      value: "Important Announcement",
    },
    {
      name: "Important Correspondence",
      value: "Important Correspondence",
    },
    {
      name: "Other",
      value: "OTHER",
    },
  ];
  @Output() dataModal = new EventEmitter<string>();

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private masterService: MasterService,
    // public dialogRef: MatDialogRef<ModalComponent>,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.isSubmitDisabled = false;
    console.log("toApplicantData", this.toApplicantData);
    console.log("exchangeType", this.exchangeType);

    this.masterService
      .fetchOtp(
        this.luser,
        this.fromApplicantData.applicationNo,
        this.toApplicantData.applicationNo,
        this.toApplicantData.tenementId,
        this.exchangeType
      )
      .subscribe(
        async (data: any) => {
          this.isLoading = false;
          if (
            data.tenementExchangeModelResponse.status === "SUCCESS" &&
            data.jwtResponse.status === "SUCCESS"
          ) {
            // if (data.jwtResponse.status === "SUCCESS") {
            this.maskMobileNumber = data.jwtResponse.maskMobileNumber;
            this.maskMobileNumberForFirstAppli =
              data.jwtResponse1.maskMobileNumber;
            if (data.jwtResponse2 !== null) {
              this.maskMobileNumberForSecondAppli =
                data.jwtResponse2.maskMobileNumber;
            } else {
              this.maskMobileNumberForSecondAppli == null;
            }

            this.pageHead = "OTP Verification";
            this.isOtpVerify = true;
            this.resendOtpTimer(120);
            // }
            if (data.jwtResponse.status == "FAILURE") {
              alert("Try After 30 Minutes : Exceeded the OTP limit");
            }
            if (data.jwtResponse.status == "ERROR") {
              alert("Please Try Again");
            }
          } else {
            this.masterService.errorToast(
              data.tenementExchangeModelResponse.errorMessage
            );
            // this.router.navigate(["/secure", "tenement-exchange", "list"]);
            this.modalCtrl.dismiss(null, "cancel");
          }
          if (data.tenementExchangeModelResponse.failurStatus === "FAILURE") {
            this.masterService.errorToast(
              data.tenementExchangeModelResponse.errorMessage
            );
            this.modalCtrl.dismiss(null, "cancel");
          }
        },

        (error) => {
          this.isLoading = false;
          this.masterService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );

    this.form = new FormGroup({
      corrigendumName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      corrigendumSelect: new FormControl(null, [
        Validators.required,
        // Validators.maxLength(255),
      ]),
    });
  }

  cancel() {
    this.modalCtrl.dismiss(null, "cancel");
  }

  onResendOtpClick() {
    // this.resendOtp = "Y";

    this.isResendOtpButtonVisible = false;
    this.resendOtp();
  }

  resendOtp() {
    this.isSubmitDisabled = false;
    this.masterService
      .resendFetchOtp(
        this.luser,
        this.fromApplicantData.applicationNo,
        this.toApplicantData.applicationNo,
        this.toApplicantData.tenementId,
        this.exchangeType
      )
      .subscribe(
        async (data: any) => {
          this.isLoading = false;
          if (
            data.tenementExchangeModelResponse.status === "SUCCESS" &&
            data.jwtResponse.status === "SUCCESS"
          ) {
            // if (data.jwtResponse.status === "SUCCESS") {
            this.maskMobileNumber = data.jwtResponse.maskMobileNumber;
            this.maskMobileNumberForFirstAppli =
              data.jwtResponse1.maskMobileNumber;
            if (data.jwtResponse2 !== null) {
              this.maskMobileNumberForSecondAppli =
                data.jwtResponse2.maskMobileNumber;
            } else {
              this.maskMobileNumberForSecondAppli == null;
            }

            this.pageHead = "OTP Verification";
            this.isOtpVerify = true;
            this.resendOtpTimer(120);
            // }
            if (data.jwtResponse.status == "FAILURE") {
              alert("Try After 30 Minutes : Exceeded the OTP limit");
            }
            if (data.jwtResponse.status == "ERROR") {
              alert("Please Try Again");
            }
          } else {
            this.masterService.errorToast(
              data.tenementExchangeModelResponse.errorMessage
            );
            // this.router.navigate(["/secure", "tenement-exchange", "list"]);
            this.modalCtrl.dismiss(null, "cancel");
          }
          if (data.tenementExchangeModelResponse.failurStatus === "FAILURE") {
            this.masterService.errorToast(
              data.tenementExchangeModelResponse.errorMessage
            );
            this.modalCtrl.dismiss(null, "cancel");
          }
          // if (data.status === "SUCCESS") {
          //   this.successToast("OTP Resend successfully.");

          //   this.maskMobileNumber = data.maskMobileNumber;
          //   this.pageHead = "OTP Verification";
          //   this.isOtpVerify = true;
          //   this.resendOtpTimer(120);
          // } else {
          //   this.masterService.errorToast(data.errorMessage);
          // }
        },
        (error) => {
          this.isLoading = false;
          this.masterService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
  }

  resendOtpTimer(remaining: any) {
    var m: any = Math.floor(remaining / 60);
    var s: any = remaining % 60;

    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    this.resendOtpIn = m + ":" + s;
    localStorage.setItem("otpResendTimeLeft", this.resendOtpIn);
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.resendOtpTimer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    } else {
      // Do timeout stuff here
      // alert('Timeout for otp');
      this.isResendOtpButtonVisible = true;
    }
  }

  resetFilter() {
    // window.location.reload();
    this.modalCtrl.dismiss(null, "cancel");
  }

  verifyOtp() {
    this.masterService
      .verifyOtp(
        this.luser,
        this.fromApplicantData.applicationNo,
        this.toApplicantData.applicationNo
      )
      .subscribe(
        (data: any) => {
          console.log(data.status == "FAILURE");
          if (data.status == "SUCCESS") {
            this.onSaveTenementDetails();
          }
          if (data.status == "FAILURE") {
            console.log("Check data for failure", data);
            alert(data.errorMessage);
          }
        },
        (error) => {
          alert("Invalid OTP");
          this._snackBar.open("Invalid username or password", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
  }

  back() {
    this.isOtpVerify = false;
    this.pageHead = "Login";
  }

  onSaveTenementDetails() {
    this.modalCtrl.dismiss("submit");
    // console.log("modalCtrl", this.modalCtrl.dismiss("submit"));
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  get corrigendumDetails() {
    return this.form.get("corrigendumLst")["controls"];
  }
}
